<template>
  <div class="download-box">
    <div class="download-container">
      <div class="title-container">
        <div style="text-align: center" class="reveal-bottom">
          <span class="title-icon"></span>
          <div class="title-name">{{ $t("m100.download_nt") }}</div>
          <div class="title-desc">{{ $t("m100.download_nt_tip") }}</div>
          <div class="title-btn">
            <div class="btn-container" @click="getDownload(netTool)">
              {{ $t("m100.c5") }}
            </div>
          </div>
          <div class="clinet-bg"></div>
        </div>
      </div>
    </div>

    <div class="download-content reveal-bottom">
      <div style="display: flex">
        <!-- Windows -->
        <div class="content-box" style="border-bottom: none">
          <div style="margin-bottom: 16px">
            <span class="content-icon window-icon"></span
            ><span class="content-name">Windows</span>
          </div>
          <div class="content-download" style="margin-bottom: 16px">
            <a
              class="content-download-a"
              :href="netTool && netTool.url"
              :dwonload="netTool && netTool.name"
              target="_blank"
            >
              <span class="content-tips">{{ $t("m100.download") }}</span>
              <span class="content-arrow"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import initAnimation from "../animation";
import axios from "@/http";
export default {
  data() {
    return {
      netTool: null,
    };
  },
  mounted() {
    setTimeout(initAnimation, 0);
  },
  created() {
    this.getData();
  },
  methods: {
    back: function () {
      this.$router.back();
    },
    getData: async function () {
      const res = await axios.get("/api2/client/side/latest");
      if (res.code === 0) {
        this.netTool = res.data.NET_TOOL;
      }
    },
    getDownload(data) {
      if (data) {
        const fileUrl = data.url; // 你实际的文件地址
        const fileName = data.name; // 下载后的文件名
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileName;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
  },
};
</script>
<style scoped>
.download-container {
  width: 100%;
  height: 844px;
  background-image: url("../../assets/images/download/download-bg.png");
  background-size: cover;
  padding-top: 100px;
  box-sizing: border-box;
}
.title-container {
  width: 1200px;
  margin: 0 auto;
}
.title-icon {
  display: inline-block;
  width: 68px;
  height: 68px;
  background-image: url("../../assets/images/download/d-nt.png");
  background-size: cover;
  margin-bottom: 24px;
}
.content-download-a {
  display: inline-block;
}
.title-name {
  height: 42px;
  line-height: 42px;
  font-weight: 500;
  font-size: 30px;
  color: #222222;
  font-style: normal;
  text-transform: none;
  margin-bottom: 24px;
}
.title-desc {
  width: 654px;
  font-weight: 400;
  font-size: 24px;
  color: #666666;
  text-align: center;
  font-style: normal;
  text-transform: none;
  display: inline-block;
  line-height: 1.5;
  margin-bottom: 48px;
}
.title-btn {
  margin-bottom: 50px;
}
.btn-container {
  display: inline-block;
  width: 164px;
  height: 50px;
  line-height: 50px;
  background: #00a3d1;
  border-radius: 0px 0px 0px 0px;
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
}
.btn2 {
  background: transparent;
  border: 1px solid #00a3d1;
  font-weight: 400;
  font-size: 20px;
  color: #00a3d1;
  font-style: normal;
  text-transform: none;
}
.clinet-bg {
  display: inline-block;
  width: 776px;
  height: 400px;
  margin: 0 auto;
  background-image: url("../../assets/images/download/nt-bg.png");
  background-size: cover;
}
.download-content {
  width: 1200px;
  padding: 60px 120px;
  margin: 0 auto;
}
.content-box {
  flex: 1;
  height: 172px;
  padding-left: 24px;
  padding-top: 24px;
  box-sizing: border-box;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.content-box:first-child {
  padding-left: 0px;
}
.content-box:last-child {
  border-right: none;
}
.content-icon {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 16px;
}
.content-name {
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #000000;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.ios-icon {
  background-image: url("../../assets/images/download/ios.png");
  background-size: cover;
}
.android-icon {
  background-image: url("../../assets/images/download/android.png");
  background-size: cover;
}
.mac-icon {
  background-image: url("../../assets/images/download/mac.png");
  background-size: cover;
}
.window-icon {
  background-image: url("../../assets/images/download/window.png");
  background-size: cover;
}
.deb-icon {
  background-image: url("../../assets/images/download/deb.png");
  background-size: cover;
}
.content-info {
  height: 28px;
  font-weight: 400;
  font-size: 20px;
  color: #909090;
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 1.5;
}
.content-tips {
  height: 28px;
  line-height: 28px;
  font-weight: 400;
  font-size: 20px;
  color: #00a3d1;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-right: 8px;
  cursor: pointer;
}
.content-arrow {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-image: url("../../assets/images/download/d-arrow.png");
  background-size: cover;
  vertical-align: top;
  margin-top: 4px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/Pages/Download/DownloadNtTool.vue